import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  generateGeoReport,
  GenerateGeoReportPayload,
} from '../../../services/geo-report/GeoReportService';
import { GET_GEO_REPORTS, GET_GEO_REPORT_USAGE } from '../../query/geo-report/keys';

export const useGenerateGeoReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: GenerateGeoReportPayload) => generateGeoReport(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_GEO_REPORTS] });
      queryClient.invalidateQueries({ queryKey: [GET_GEO_REPORT_USAGE] });
    },
  });
};